var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('material-card',{attrs:{"color":"#ed2224","title":"Sales Tracking","offset":"0"}},[_c('div',{attrs:{"slot":"header-actions"},slot:"header-actions"},[_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){return _vm.resetFilters()}}},[_vm._v("Clear Grid Filters")])],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }